import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-prevoyance-entreprise',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-prevoyance-entreprise.component.html',
  styleUrls: ['./assurance-prevoyance-entreprise.component.scss']
})
export class AssurancePrevoyanceEntrepriseComponent {
  title = 'Assurance Prévoyance Entreprise';
  subtitle = '';
  heroVideo = 'assets/videos/prevoyance.mp4';
  
  breadcrumbs = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance Prévoyance', link: undefined }
  ];

  prevPage = {
    title: 'Assurance Prévoyance Professionnelle',
    link: '/assurance-prevoyance-professionnelle'
  };

  nextPage = {
    title: 'Assurance Retraite Complémentaire Professionnelle',
    link: '/assurance-retraite-complementaire-pro'
  };

  constructor(private router: Router) {}

  navigateToContact() {
    this.router.navigate(['cac/contact']);
  }
}
